import { render, staticRenderFns } from "./RelatieDashboard.vue?vue&type=template&id=6afadd88"
import script from "./RelatieDashboard.vue?vue&type=script&lang=js"
export * from "./RelatieDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports